import { and, createActor, setup } from 'xstate';
import {
  NavigationWizardModeSectionParams,
  NavigationWizardModeState,
  NavigationWizardModeStateMachineInput,
  NavigationWizardModeStateMachineOutput,
} from 'views/BrTabs/types/navigationWizardMode';
import { BrTypes } from 'types/BrTypes';
import { BrTabItems } from 'views/BrTabs/BrTabs';

export const navigationWizardModeMachine = setup({
  types: {
    input: {} as NavigationWizardModeStateMachineInput,
    context: {} as NavigationWizardModeStateMachineInput,
  },
  guards: {
    isWena: ({ context }) => context.isWena,
    isClmBr: ({ context }) => context.isClmBr,
    isPrivateBankingBrType: ({ context }) =>
      context.brTypeFromStore !== undefined && context.brTypeFromStore !== BrTypes.INTERMEDIARY_B2B,
    isIntermediaryB2BBrType: ({ context }) => context.brTypeFromStore === BrTypes.INTERMEDIARY_B2B,
    hasAllIntermediaryFlags: ({ context }) =>
      Boolean(
        context.featureFlags?.zfBrCoreDataIntermediary?.enabled &&
          context.featureFlags?.zfBrRelationsIntermediary?.enabled &&
          context.featureFlags?.zfServicingUsersIntermediary?.enabled &&
          context.featureFlags?.zfBrPurposeIntermediary?.enabled,
      ),
    isProfilingTab: ({ context }) => context.selectedTab === BrTabItems.BR_PURPOSE,
    isIntermediaryReducedTab: ({ context }) =>
      [BrTabItems.CORE_DATA, BrTabItems.BR_PURPOSE, BrTabItems.BR_SERVICING, BrTabItems.BR_RELATIONS].includes(
        context.selectedTab,
      ),
  },
}).createMachine({
  id: 'navigationWizardMode',
  context: ({ input }) => input,
  initial: 'wenaCheck',
  states: {
    wenaCheck: {
      always: [{ guard: 'isWena', target: 'full' }, { target: 'brSourceCheck' }],
    },
    brSourceCheck: {
      always: [{ guard: 'isClmBr', target: 'clmBrCheck' }, { target: 'crmBrCheck' }],
    },
    clmBrCheck: {
      always: [{ guard: 'isPrivateBankingBrType', target: 'full' }, { target: 'intermediaryB2BCheck' }],
    },
    intermediaryB2BCheck: {
      always: [
        {
          guard: and(['isIntermediaryB2BBrType', 'hasAllIntermediaryFlags', 'isIntermediaryReducedTab']),
          target: 'reduced',
        },
        { target: 'hidden' },
      ],
    },
    crmBrCheck: {
      always: [{ guard: 'isProfilingTab', target: 'legacy' }, { target: 'hidden' }],
    },
    full: {},
    legacy: {},
    reduced: {},
    hidden: {},
  },
});

export function resolveNavigationWizardMode(
  params: NavigationWizardModeSectionParams,
): NavigationWizardModeStateMachineOutput {
  const actor = createActor(navigationWizardModeMachine, { input: params });
  actor.start();
  const state = actor.getSnapshot().value as NavigationWizardModeState;
  actor.stop();
  return { type: state };
}
